import React from "react";
import DevIcon from "devicon-react-svg";
import "./Skills.css";

function Skills() {
  const skills = [
    {
      name: "HTML",
      icon: "html5",
    },
    {
      name: "CSS",
      icon: "css3",
    },
    {
      name: "JavaScript",
      icon: "javascript",
    },
    {
      name: "Python",
      icon: "python",
    },
    {
      name: "Django",
      icon: "django",
    },
    {
      name: "React",
      icon: "react",
    },
    {
      name: "MongoDB",
      icon: "mongodb",
    },
    {
      name: "Bootstrap",
      icon: "bootstrap",
    },
    {
      name: "Git",
      icon: "git",
    },
    {
      name: "MySQL",
      icon: "mysql",
    },
    {
      name: "Node",
      icon: "nodejs",
    },
    {
      name: "VsCode",
      icon: "visualstudio",
    },
    {
      name: "PyCharm",
      icon: "pycharm",
    },
  ];
  return (
    <section id="skills" className="container section">
      <div className="row">
        <div
          className="col-md-10"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          <h2 id="skill_header" className="section__title">
            My Skills_
          </h2>
        </div>
      </div>
      <div className="skill_card_container">
        {skills.map((skill, index) => {
          return (
            <div
              id={index}
              key={index}
              className="skill_card"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <DevIcon
                icon={skill.icon}
                style={{
                  height: "70px",
                  backgroundColor: "white",
                  borderRadius: "50%",
                }}
              />
              <span style={{ margin: "5px", fontSize: "1.5rem" }}>
                {skill.name}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Skills;
